export enum PermissionType {
  ClaimsCoreSysAdmin = "ClaimsCoreSysAdmin",
  ClaimsCoreBusAdmin = "ClaimsCoreBusAdmin",
  ClaimsCoreClaimMgr = "ClaimsCoreClaimMgr",
  ClaimsCoreClaimUsr = "ClaimsCoreClaimUsr",
  ClaimsCoreInquiryonlyUser = "ClaimsCoreInquiryonlyUser",
}
